import { PreviewCanvasScale } from "./shared/preview-canvas-scale";

const INTER_TABULAR = {
  fontFeatureSettings: '"ss03" 1, "ss01" 1, "zero" 1, "ss02" 1',
} as const;

/** Remaining-balance chart bounds inside the white panel. */
const CHART_W = 330;
const CHART_H = 40;

/**
 * A Term Loan at the calculator's resting defaults (100k, 10% fee, 9 months,
 * daily repayments) pays down in a straight line from the total to zero.
 */
const LINE_PATH = `M0 0 L${CHART_W} ${CHART_H}`;
const AREA_PATH = `M0 0 L${CHART_W} ${CHART_H} L0 ${CHART_H} Z`;

/**
 * Offer visualisation card inset. Mirrors the tool's results panel: total to
 * repay with its breakdown, over the remaining-balance chart. The card clips
 * the canvas at ~180px, so the chart sits directly under the breakdown.
 */
export function OfferVisualisationPreview() {
  return (
    <PreviewCanvasScale testId="offer-visualisation-canvas">
      <p
        className="text-grey-950 absolute top-[29px] left-[29px] text-[12px] leading-[1.4] whitespace-nowrap"
        style={INTER_TABULAR}
      >
        Total to repay
      </p>

      <div className="border-grey-100 absolute top-[59px] left-[23px] h-[200px] w-[441px] overflow-hidden rounded-[10px] border bg-white">
        <div
          className="absolute top-[14.69px] left-[14.69px] flex flex-col gap-1"
          style={INTER_TABULAR}
        >
          <p className="text-grey-950 text-[36px] leading-none font-medium tracking-[-0.02em]">
            $110,000
          </p>
          <p className="text-grey-500 text-[10px] leading-[1.4] whitespace-nowrap">
            $100,000 funding + $10,000 fixed fee
          </p>
        </div>

        <svg
          aria-hidden
          viewBox={`-6 -6 ${CHART_W + 12} ${CHART_H + 12}`}
          width={CHART_W + 12}
          height={CHART_H + 12}
          className="absolute top-[72px] left-[8.69px] overflow-visible"
        >
          <defs>
            <linearGradient
              id="offer-visualisation-preview-area"
              x1="0"
              y1="0"
              x2="0"
              y2="1"
            >
              <stop
                offset="0%"
                stopColor="var(--pulse-700)"
                stopOpacity="0.14"
              />
              <stop
                offset="100%"
                stopColor="var(--pulse-700)"
                stopOpacity="0"
              />
            </linearGradient>
          </defs>
          <line
            x1={0}
            y1={CHART_H}
            x2={CHART_W}
            y2={CHART_H}
            stroke="var(--grey-100)"
            strokeWidth={1}
          />
          <path d={AREA_PATH} fill="url(#offer-visualisation-preview-area)" />
          <path
            d={LINE_PATH}
            fill="none"
            stroke="var(--pulse-700)"
            strokeWidth={2}
            strokeLinecap="round"
          />
          <circle
            cx={CHART_W}
            cy={CHART_H}
            r={5}
            fill="var(--pulse-700)"
            stroke="var(--grey-0)"
            strokeWidth={2}
          />
        </svg>
      </div>
    </PreviewCanvasScale>
  );
}
